export default function parseProfileUrl({ url }) {
  try {
    const u = new URL(String(url).trim());
    const host = u.hostname.replace(/^www\./, "").toLowerCase();
    const parts = u.pathname.replace(/^\/|\/$/g, "").split("/").filter(Boolean);

    const platformMap = {
      "instagram.com": "Instagram",
      "tiktok.com": "TikTok",
      "twitter.com": "Twitter",
      "x.com": "Twitter",
      "facebook.com": "Facebook",
      "youtube.com": "YouTube",
      "linkedin.com": "LinkedIn",
    };
    const platform = platformMap[host];
    if (!platform) throw new Error("Unsupported or invalid platform detected.");

    let username;
    switch (platform) {
      case "Instagram":
      case "Twitter":
      case "Facebook":
        username = parts[0];
        break;
      case "TikTok":
        username = (parts[0] || "").replace(/^@/, "");
        break;
      case "YouTube":
        if (parts[0]?.startsWith("@")) username = parts[0].slice(1);
        else if (parts[0] === "channel" && parts[1]) username = parts[1];
        else if (["c", "user"].includes(parts[0]) && parts[1]) username = parts[1];
        break;
      case "LinkedIn":
        if (["in", "company", "school"].includes(parts[0]) && parts[1]) username = parts[1];
        else username = parts[0];
        break;
    }
    if (!username) throw new Error("Invalid URL format. No username detected.");

    u.hash = "";
    u.search = "";
    const link = `${u.protocol}//${u.host}${u.pathname.replace(/\/{2,}/g, "/").replace(/\/+$/, "") || "/"}`;

    return { platform, username, link };
  } catch {
    throw new Error("Invalid or malformed profile URL. Please enter a correct URL.");
  }
}

